import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "./data";
import { Reveal } from "./Reveal";

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="bg-ink py-24 md:py-40">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end mb-16 md:mb-24">
          <Reveal className="md:col-span-8">
            <p className="font-heading text-xs uppercase tracking-[0.3em] font-bold text-terracotta mb-6">
              [ 01 ] — What we do
            </p>
            <h2 className="font-heading font-extrabold uppercase text-bone tracking-tight leading-[0.9] text-4xl md:text-6xl lg:text-7xl">
              Services cut <br />
              <span className="text-stone">to the millimetre</span>
            </h2>
          </Reveal>
          <Reveal className="md:col-span-4" delay={0.15}>
            <p className="font-body font-light text-stone text-base md:text-lg leading-relaxed">
              Five disciplines, one obsession: joints that run dead straight and
              surfaces that read perfectly flat under raking light.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 border-t border-l border-line">
          {SERVICES.map((s, i) => (
            <Reveal
              key={s.no}
              delay={i * 0.08}
              className={
                i === 0
                  ? "md:col-span-6 md:row-span-2"
                  : "md:col-span-6"
              }
            >
              <a
                href="#contact"
                data-testid={`service-card-${s.no}`}
                className="group relative flex h-full flex-col justify-between border-r border-b border-line bg-surface hover:bg-surfaceHover transition-colors duration-500 overflow-hidden"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="h-full w-full object-cover opacity-70 group-hover:opacity-100 group-hover:scale-105 transition-all duration-[900ms] ease-out"
                  />
                  <span className="absolute top-5 left-5 font-heading text-xs tracking-[0.2em] font-bold text-bone/70">
                    {s.no}
                  </span>
                </div>
                <div className="p-8 md:p-10 flex items-start justify-between gap-6">
                  <div>
                    <h3 className="font-heading text-2xl md:text-3xl font-bold text-bone mb-3 tracking-tight">
                      {s.title}
                    </h3>
                    <p className="font-body font-light text-stone max-w-sm leading-relaxed">
                      {s.desc}
                    </p>
                  </div>
                  <ArrowUpRight
                    size={26}
                    className="shrink-0 text-stone group-hover:text-terracotta group-hover:rotate-45 transition-all duration-300"
                  />
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
